import LinkTypeShape, {
  AlternateType,
  AlternatesType,
  LINK_TYPE_WEB,
  LINK_TYPE_DOC,
  LINK_TYPE_MEDIA,
} from './link';

export {
  LINK_TYPE_WEB,
  LINK_TYPE_DOC,
  LINK_TYPE_MEDIA,
  AlternateType,
  AlternatesType,
  LinkTypeShape,
};

export const HOME_ARTICLES_KEY = 'home-articles';
export const ARTICLES_KEY = 'articles';
